import {
    createContext, Dispatch, Key, SetStateAction,
} from 'react';

export interface IDocumentCodesContextArgs {
    entityName: string;
    selectedTabKey: Key | null;
    setSelectedTabKey: Dispatch<SetStateAction<Key>> | null;
    templateCode?: string;
}

export const DocumentCodesTemplateContext = createContext<IDocumentCodesContextArgs>({
    entityName: '',
    selectedTabKey: null,
    setSelectedTabKey: null,
});
